import type { ReactNode } from 'react';

import Box from '@mui/material/Box';
import type { BoxProps } from '@mui/material/Box';

import { normalizeSx } from '@/shared/lib/normalizeSx';

import type { Sx } from '@/shared/types/uiTypes';

interface TabPanelProps extends Omit<BoxProps, 'children' | 'sx'> {
  children?: ReactNode;
  index: number;
  value: number;
  sx?: Sx;
  className?: string;
  containerSX?: Sx;
}

const CustomTabPanel = ({
  children,
  value,
  index,
  sx,
  className,
  containerSX,
  ...other
}: TabPanelProps) => {
  return (
    <Box
      aria-labelledby={`tab-${index}`}
      className={className}
      hidden={value !== index}
      id={`tabpanel-${index}`}
      role='tabpanel'
      sx={containerSX}
      {...other}
    >
      {value === index && <Box sx={normalizeSx(sx)}>{children}</Box>}
    </Box>
  );
};

export default CustomTabPanel;
